export default __webpack_public_path__ + "static/media/BarcodeBtn.b6b9b182.svg";